// extracted by mini-css-extract-plugin
module.exports = {"container":"SetNewPasswordView__container","text":"SetNewPasswordView__text","form":"SetNewPasswordView__form"};